import Header from "@/components/header";
import Footer from "@/components/home/footer";
import Seo from "@/components/seo";
import { GlossaryList } from "@utils/glossaryList";
import Link from "next/link";
import GlossarySidebarList from "@/components/glossary/GlossarySlidebarList";

const sortAlphabetically = (arr) => {
  const sortedArray = arr.sort((a, b) => {
    const itemA = a.title;
    const itemB = b.title;
    return itemA.localeCompare(itemB);
  });

  return sortedArray;
};

const Glossary = () => {
  return (
    <>
      <Seo
        title="Glossary of Accounting Terms | Pinto Financial"
        description="The love language of business numbers. A quick guide to key accounting terms and what they really mean."
      />

      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-16">

        <div className="mt-14 flex justify-between">

          <GlossarySidebarList />
          
          <div>

            {/* Glossary Header */}
            <div className="bg-white py-12 sm:py-12 ">
              <div className="mx-auto max-w-7xl px-0 sm:px-8">
                <div className="max-w-2xl lg:mx-0">
                  <h2 className="text-4xl tracking-tight text-gray-900 sm:text-6xl">Accounting Terms Glossary</h2>
                  <p className="mt-6 text-lg leading-8 text-gray-600">
                    The love language of business numbers. A quick guide to each key accounting term and what they really mean.
                  </p>
                </div>
              </div>
            </div>


            {sortAlphabetically(GlossaryList).map((i) => (
              <div key={i.title} className="text-start ml-0 mb-16 sm:ml-8 ">
                <h2 className="text-xl font-semibold">{i.title}</h2>
                <p className="my-2">{i.definition}</p>
                <Link
                  className="transition hover:underline hover:text-pinto text-base font-semibold leading-7 text-gray-900"
                  href={`/glossary/${i.slug}`}
                >
                  Read more
                  <span aria-hidden="true"> &rarr;</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Glossary;
